import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toBackendUrl } from "@/lib/utils";

export default function HeadIcons() {
  const { company } = useAuth();
  useEffect(() => {
    const head = document.head;
    if (!head) return;
    const ensureLink = (rel, href, sizes) => {
      if (!href) return;
      let el = head.querySelector(`link[rel='${rel}']`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        head.appendChild(el);
      }
      el.setAttribute("href", href);
      if (sizes) el.setAttribute("sizes", sizes);
    };
    if (company?.logoUrl) {
      const url = toBackendUrl(company.logoUrl);
      // iOS home screen icon
      ensureLink("apple-touch-icon", url, "180x180");
      // Fallback favicons for some Android launchers
      ensureLink("icon", url);
      ensureLink("shortcut icon", url);
    }
  }, [company?.logoUrl]);
  return null;
}
